// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1oNeh","containerItemsCenter":"Skeleton_containerItemsCenter__3rPHY"};